import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import Home from '@/views/publicView/Home'
import Mine from '@/views/publicView/Mine'
import wordIndex from '@/views/word/wordIndex'
// 注册登录
import Login from '@/views/sys/Login'
import Register from '@/views/sys/Register'
import Retrieve from  '@/views/sys/Retrieve'

import clockIn from '@/views/clockIn/clockIn'

//单词搜索
import WordSearch from '@/views/word/WordSearch'
import cellIndex from '@/views/word/cell/index'
import indexSelect from '@/views/word/cell/indexSelect'
import indexFavorites from '@/views/word/cell/indexFavorites'

//单词列表
import pmsSumCellList from '@/views/word/pmsSumUnitCellList'
import pmsUnitCellList from '@/views/word/pmsUnitCellList'

//收藏夹
import favoritesList from '@/views/word/favorites/favoritesList'

//练习测试
import practiceSelectList from '@/views/word/practice/selectList'
//练习测试
import practiceTable from '@/views/word/practice/practiceTable'
import wordTest from '@/views/word/practice/wordTest'
import wordSelect from '@/views/word/practice/wordSelect'
import wordMatch from '@/views/word/practice/wordMatch'

//我的 
//关于我们
import gywm from '@/views/publicView/me/gywm'
import cjwt from '@/views/publicView/me/cjwt'
import updatePassword from '@/views/sys/updatePassword'
import profileEdit from '@/views/sys/profileEdit'
import activation from '@/views/publicView/me/activation'
import myBooks from '@/views/publicView/me/myBooks'

import yhfwxy_display from '@/views/publicView/me/yhfwxy_display'
import wtlb_display from '@/views/publicView/me/wtlb_display'

// 三大模块
import reviewHome from '@/views/new/review/home'
import reviewPractice from '@/views/new/review/practice'
import reviewErrorBook from '@/views/new/review/errorBook'
import statsHome from '@/views/new/stats/home'
import statsWeekly from '@/views/new/stats/weeklyReport'
import statsCalendar from '@/views/new/stats/calendar'
import checkinCalendar from '@/views/new/checkin/calendar'
import checkinRanking from '@/views/new/checkin/ranking'
import achievementList from '@/views/new/achievement/list'
import pointsLog from '@/views/new/points/log'

// 四大创新功能
import mpHome from '@/views/innovation/memory-palace/index'
import mpCreate from '@/views/innovation/memory-palace/create'
import mpDetail from '@/views/innovation/memory-palace/detail'
import mpAnchorEdit from '@/views/innovation/memory-palace/anchor-edit'
import mpRoam from '@/views/innovation/memory-palace/roam'
import mpTest from '@/views/innovation/memory-palace/test'
import mpResult from '@/views/innovation/memory-palace/result'
import mpGallery from '@/views/innovation/memory-palace/gallery'
import mpShare from '@/views/innovation/memory-palace/share'
import cpHome from '@/views/innovation/context-puzzle/index'
import cpStart from '@/views/innovation/context-puzzle/scene-start'
import cpPuzzle from '@/views/innovation/context-puzzle/puzzle'
import cpResult from '@/views/innovation/context-puzzle/result'
import cpCard from '@/views/innovation/context-puzzle/card'
import cpCollection from '@/views/innovation/context-puzzle/collection'
import etHome from '@/views/innovation/etymology-tree/index'
import etCreate from '@/views/innovation/etymology-tree/create'
import etDetail from '@/views/innovation/etymology-tree/detail'
import etMembers from '@/views/innovation/etymology-tree/members'
import etRootDetail from '@/views/innovation/etymology-tree/root-detail'
import etJoin from '@/views/innovation/etymology-tree/join'
import etWater from '@/views/innovation/etymology-tree/water'
import etMessages from '@/views/innovation/etymology-tree/messages'
import slHome from '@/views/innovation/story-ladder/index'
import slContest from '@/views/innovation/story-ladder/contest-detail'
import slTeam from '@/views/innovation/story-ladder/team-room'
import slWrite from '@/views/innovation/story-ladder/write'
import slRank from '@/views/innovation/story-ladder/rank'
import slCollections from '@/views/innovation/story-ladder/collections'

export const constantRouterMap = [
  {
    path: '/yhfwxy_display',
    name: 'yhfwxy_display',
    component: yhfwxy_display
  }, 
  {
    path: '/activation',
    name: 'activation',
    component: activation
  },
  {
    path: '/myBooks',
    name: 'myBooks',
    component: myBooks
  },
  {
    path: '/updatePassword',
    name: 'updatePassword',
    component: updatePassword
  },
  {
    path: '/profileEdit',
    name: 'profileEdit',
    component: profileEdit
  },
  {
    path: '/wtlb_display',
    name: 'wtlb_display',
    component: wtlb_display
  }, 

  {
    path: '/gywm',
    name: 'gywm',
    component: gywm
  }, 
  {
    path: '/cjwt',
    name: 'cjwt',
    component: cjwt
  }, 
  {
    path: '/practiceTable_display',
    name: 'practiceTable_display',
    component: practiceTable
  },
  {
    path: '/wordTest_display',
    name: 'wordTest_display',
    component: wordTest
  },
  {
    path: '/wordSelect_display',
    name: 'wordSelect_display',
    component: wordSelect
  },
  {
    path: '/wordMatch_display',
    name: 'wordMatch_display',
    component: wordMatch
  },
  {
    path: '/practiceSelectList_display',
    name: 'practiceSelectList_display',
    component: practiceSelectList
  },
  {
    path: '/login_display',
    name: 'HelloWorld',
    component: Mine
  },{
    path: '/wordIndex',
    name: 'wordIndex',
    component: wordIndex
  }
  ,{
    path: '/wordIndex_displa',
    name: 'wordIndex_displa',
    component: wordIndex
  }
  ,
  {
    path: '/indexFavorites_display',
    name: 'indexFavorites_display',
    component: indexFavorites
  },
  {
    path: '/cellIndex_display',
    name: 'cellIndex_display',
    component: cellIndex

  },
  {
    path: '/indexSelect_display',
    name: 'indexSelect_display',
    component: indexSelect
  },
  {
    path: '/favoritesList_display',
    name: 'favoritesList_display',
    component: favoritesList
  },
  {
    path: '/mine',
    name: 'Mine',
    meta: {
      keep_alive: true // 需要被缓存
    },
    component: Mine
  },
   { //单词查找
    path: '/wordSearch_display',
    name: 'wordSearch_display',
    component: WordSearch
  }
  //注册登录模块
  ,{
    path: '/sysLogin_display',
    name: 'sysLogin_display',
    component: Login
  },{
    path: '/',
    //redirect: '/cert_hideTabBar',
    redirect: '/wordIndex',
    component: Login
  },{
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/practice',
    name: 'Practice',
    meta: { keep_alive: true },
    component: practiceSelectList
  },
  { //注册
    path: '/sysRegister_display',
    name: 'sysRegister_display',
    component: Register
  },
  { //注册
    path: '/sysRetrieve_pass_display',
    name: 'sysRetrieve_pass_display',
    component: Retrieve
  },
  { //打卡
    path: '/clockIn',
    name: 'clockIn',
    component: clockIn
  },
  { //单词列表
    path: '/pmsCellList_display',
    name: 'pmsCellList_display',
    component: pmsSumCellList
  }
  ,
  { //子单词列表
    path: '/pmsUnitCellList_display',
    name: 'pmsUnitCellList_display',
    component: pmsUnitCellList
  },
  { path: '/reviewHome_display', name: 'reviewHome_display', component: reviewHome },
  { path: '/reviewPractice_display', name: 'reviewPractice_display', component: reviewPractice },
  { path: '/reviewErrorBook_display', name: 'reviewErrorBook_display', component: reviewErrorBook },
  { path: '/statsHome_display', name: 'statsHome_display', component: statsHome },
  { path: '/statsWeekly_display', name: 'statsWeekly_display', component: statsWeekly },
  { path: '/statsCalendar_display', name: 'statsCalendar_display', component: statsCalendar },
  { path: '/checkinCalendar_display', name: 'checkinCalendar_display', component: checkinCalendar },
  { path: '/checkinRanking_display', name: 'checkinRanking_display', component: checkinRanking },
  { path: '/achievementList_display', name: 'achievementList_display', component: achievementList },
  { path: '/pointsLog_display', name: 'pointsLog_display', component: pointsLog },
  { path: '/mpHome_display', name: 'mpHome_display', component: mpHome },
  { path: '/mpCreate_display', name: 'mpCreate_display', component: mpCreate },
  { path: '/mpDetail_display', name: 'mpDetail_display', component: mpDetail },
  { path: '/mpAnchorEdit_display', name: 'mpAnchorEdit_display', component: mpAnchorEdit },
  { path: '/mpRoam_display', name: 'mpRoam_display', component: mpRoam },
  { path: '/mpTest_display', name: 'mpTest_display', component: mpTest },
  { path: '/mpResult_display', name: 'mpResult_display', component: mpResult },
  { path: '/mpGallery_display', name: 'mpGallery_display', component: mpGallery },
  { path: '/mpShare_display', name: 'mpShare_display', component: mpShare },
  { path: '/cpHome_display', name: 'cpHome_display', component: cpHome },
  { path: '/cpStart_display', name: 'cpStart_display', component: cpStart },
  { path: '/cpPuzzle_display', name: 'cpPuzzle_display', component: cpPuzzle },
  { path: '/cpResult_display', name: 'cpResult_display', component: cpResult },
  { path: '/cpCard_display', name: 'cpCard_display', component: cpCard },
  { path: '/cpCollection_display', name: 'cpCollection_display', component: cpCollection },
  { path: '/etHome_display', name: 'etHome_display', component: etHome },
  { path: '/etCreate_display', name: 'etCreate_display', component: etCreate },
  { path: '/etDetail_display', name: 'etDetail_display', component: etDetail },
  { path: '/etMembers_display', name: 'etMembers_display', component: etMembers },
  { path: '/etRootDetail_display', name: 'etRootDetail_display', component: etRootDetail },
  { path: '/etJoin_display', name: 'etJoin_display', component: etJoin },
  { path: '/etWater_display', name: 'etWater_display', component: etWater },
  { path: '/etMessages_display', name: 'etMessages_display', component: etMessages },
  { path: '/slHome_display', name: 'slHome_display', component: slHome },
  { path: '/slContest_display', name: 'slContest_display', component: slContest },
  { path: '/slTeam_display', name: 'slTeam_display', component: slTeam },
  { path: '/slWrite_display', name: 'slWrite_display', component: slWrite },
  { path: '/slRank_display', name: 'slRank_display', component: slRank },
  { path: '/slCollections_display', name: 'slCollections_display', component: slCollections }
]


export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}


// WEBPACK FOOTER //
// ./src/router/index.js